import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { UserPlus, ArrowLeft, Gift } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { useCustomerAuth } from "../context/CustomerAuthContext";

export default function CustomerRegister() {
  const { customer, register } = useCustomerAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (customer) return <Navigate to="/area-clienti" replace />;

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) navigate("/area-clienti");
    else setError(res.error);
  };

  const field = (label, key, type = "text", placeholder = "") => (
    <div>
      <label className="label-eyebrow text-navy-soft">{label}</label>
      <input
        type={type}
        value={form[key]}
        onChange={set(key)}
        required
        data-testid={`customer-register-${key}`}
        className="w-full bg-surface border border-line focus:border-brand rounded-xl px-4 py-3 outline-none transition-colors text-navy"
        placeholder={placeholder}
      />
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <section className="flex-1 bg-surface flex items-center justify-center px-5 py-16">
        <div className="w-full max-w-md bg-white rounded-3xl border border-line soft-shadow-lg p-8 sm:p-10" data-testid="customer-register-card">
          <Link to="/" className="inline-flex items-center gap-2 text-xs text-navy-soft hover:text-brand mb-6">
            <ArrowLeft className="w-3.5 h-3.5" /> Torna alla home
          </Link>
          <div className="w-12 h-12 rounded-2xl bg-brand-light text-brand-darker flex items-center justify-center mb-5">
            <UserPlus className="w-6 h-6" />
          </div>
          <h1 className="font-heading font-extrabold text-3xl text-navy">Crea il tuo account</h1>
          <div className="mt-3 flex items-start gap-2 text-sm text-brand-darker bg-brand-light/60 rounded-xl px-3 py-2.5">
            <Gift className="w-4 h-4 mt-0.5 shrink-0" />
            <span>Registrandoti ricevi subito la tua <strong>Carta Fedeltà</strong> gratuita.</span>
          </div>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            {field("Nome e cognome", "name", "text", "Mario Rossi")}
            {field("Email", "email", "email", "latua@email.it")}
            {field("Telefono", "phone", "tel", "333 1234567")}
            {field("Password", "password", "password", "Almeno 6 caratteri")}
            {error && <div className="text-sm text-destructive font-medium" data-testid="customer-register-error">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="customer-register-submit"
              className="w-full bg-brand hover:bg-brand-dark text-white font-bold py-3.5 rounded-full transition-colors disabled:opacity-60"
            >
              {loading ? "Creazione…" : "Registrati"}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-navy-soft">
            Hai già un account?{" "}
            <Link to="/area-clienti/login" data-testid="customer-go-login" className="font-bold text-brand-dark hover:underline">
              Accedi
            </Link>
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
